import type Highcharts from "highcharts";

declare module "highcharts" {
  interface LegendOptions {
    onHover?: (series: Highcharts.Series) => void;
    onMouseOut?: (series: Highcharts.Series) => void;
  }
}

export default function legendItemHoverCallback(H: typeof Highcharts) {
  H.wrap(
    H.Legend.prototype,
    "setItemEvents",
    function (
      this: Highcharts.Legend,
      proceed: {
        apply: (
          arg0: Highcharts.Legend,
          arg1: [Highcharts.Series | Highcharts.Point, SVGElement],
        ) => void;
      },
      ...args: [Highcharts.Series | Highcharts.Point, SVGElement]
    ) {
      proceed.apply(this, args);

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const item = args[0] as any;
      const legendItem = args[1];
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const useHTML = (args as any)[2] as boolean | undefined;
      const legendItems = useHTML ? [legendItem, item.legendSymbol] : [item.legendGroup];

      if (this.chart.options.legend?.onHover) {
        const callback = this.chart.options.legend?.onHover;
        for (const element of legendItems) {
          if (element.element) {
            element.element.addEventListener("mouseover", () => {
              callback(item);
            });
          }
        }
      }

      if (this.chart.options.legend?.onMouseOut) {
        const callback = this.chart.options.legend?.onMouseOut;
        for (const element of legendItems) {
          if (element.element) {
            element.element.addEventListener("mouseout", () => {
              callback(item);
            });
          }
        }
      }
    },
  );
}
